import fly from "flyio";
//添加请求拦截器
fly.interceptors.request.use(request => {
  //打印出请求体
  // console.log(request)
  request.headers["Authorization"] =
    "Bearer " + cookie.get("accessToken") || "";
  request.headers["Content-Type"] = "application/json";

  // request.headers['auth'] = cookie.get('auth') || ''

  request.headers["auth"] = cookie.get("auth");
  //终止请求
  //var err=new Error("xxx")
  //err.request=request
  //return Promise.reject(new Error(""))
  //可以显式返回request, 也可以不返回，没有返回值时拦截器中默认返回request
  return request;
});

//添加响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use(
  response => {
    //只将请求结果的data字段返回
    return response;
  },
  err => {
    //发生网络错误后会走到这里
    if (!cookie.get("accessToken") && err.status == 401) {
      this.$message.warning("无登录信息或登录超时,请重新登录!");
      this.$router.push({
        path: "/Login"
      });
      return;
    }
    //return Promise.resolve("ssss")
  }
);

// const PORT = 'https://photo.aavisa.com/app_api',RPRT2 = 'https://photo.aavisa.com/api' // 线上
// const PORT = 'https://testphoto.aavisa.com/app_api',RPRT2 = 'https://testphoto.aavisa.com/api'// 测试
// const RPRT3 = 'https://vias.cn/visarebot'

const PORT = "/api",
  RPRT2 = "https://photo.aavisa.com/api",
  RPRT3 = "/VISA"; // 线上
// const PORT = 'https://testphoto.aavisa.com/app_api',RPRT2 = 'https://testphoto.aavisa.com/api'// 测试
// const PORT = 'http://localhost:8080/api',RPRT2 = 'https://photo.aavisa.com/api' // 线上
const RPRT4 = "https://vias.cn/visarebot";

//热门国家
export const GetHotCountry = params =>
  fly.get(`${RPRT3}/Product/GetHotCountryProduct`, params);
//预约动态
export const GetCountryBook = params =>
  fly.get(`${PORT}/CountryBook/GetList`, params);
//获取轮播图
export const GetBanner = params => fly.get(`${RPRT3}/Home/GetBanner`, params);

// 预约国家
export const GetCountryBookList = params =>
  fly.post(`${PORT}/CountryBook/GetCountrylist`, params);

//领馆假期
export const GetCountryHoliday = params =>
  fly.get(`${PORT}/CountryHoliday/GetList`, params);

// 领馆国家
export const GetCountryHolidayList = params =>
  fly.post(`${PORT}/CountryHoliday/GetCountrylist`, params);

//签证资讯
export const GetNewsConsult = params =>
  fly.get(`${RPRT3}/Home/GetNews`, params);

//新闻详情
export const GetNewsDetails = params =>
  fly.get(`${RPRT3}/Home/GetNewsDetail`, params);

// 国家列表
export const GetCountrys = params =>
  fly.get(`${PORT}/VisaProduct/GetCountrysNew`, params);

// 校验登录
export const CheckCodeLogin = params =>
  fly.get(`${RPRT3}/Login/CheckCodeLogin`, params);

// 根据国家查询
export const GetProduct = params =>
  fly.get(`${RPRT3}/Product/GetProductPc`, params);

export const GetVisaList = params =>
  fly.get(`${PORT}/VisaProduct/GetVisaList`, params);

// 搜索框-国家
export const SeachCountry = params =>
  fly.get(`${PORT}/VisaProduct/SeachCountry`, params);

// 产品详情
export const GetDetail = params =>
  fly.get(`${RPRT3}/Product/GetDetail`, params);
export const VisaDetial = params =>
  fly.get(`${PORT}/VisaProduct/VisaDetial`, params);

// pdf下载资料
export const ExportPdfDetail = params =>
  fly.get(`${RPRT3}/Product/ExportPdfDetail`, params);

// word下载资料
export const ExportWordDetail = params =>
  fly.get(`${RPRT3}/Product/ExportWordDetail`, params);
// 获取公司信息
export const GetCompany = params =>
  fly.get(`${PORT}/UserInfo/GetCompany`, params);
//下单
export const PostOrder = params => fly.get(`${RPRT3}/StartForm/Save`, params);
//获取订单详情
export const GetOrderDetail = params =>
  fly.get(`${PORT}/VisaOrder/getVisaOrderBasicData`, params);
//修改订单和优惠信息
export const PlaceOrder = params =>
  fly.post(`${PORT}/PayMent/PlaceOrder`, params);
//收货地址列表
export const GetAddressList = params =>
  fly.get(`${PORT}/Address/GetAddressList`, params);

//编辑地址
export const EditAddressDetail = params =>
  fly.post(`${PORT}/Address/EditDetail`, params);
//删除地址
export const DelAddress = params =>
  fly.get(`${PORT}/Address/DelAddress`, params);
//设为默认地址
export const SetDefaultAddress = params =>
  fly.get(`${PORT}/Address/SetDefault`, params);

//新增收件地址
export const AddAddress = params =>
  fly.post(`${PORT}/Address/AddDetail`, params);
export const SFOrder = params => fly.post(`${PORT}/VisaOrder/SFOrder`, params);

//获取订单列表
export const GetOrderList = params =>
  fly.get(`${RPRT3}/Member/GetOrderListPC`, params);
//取消订单
export const CancelOrder = params =>
  fly.get(`${RPRT3}/Member/CancelOrder`, params);
export const GetPassengerProgress = params =>
  fly.get(`${PORT}/OrderAudit/GetPassengerProgress`, params);

//账单列表
export const GetBillFlowAll = params =>
  fly.get(`${PORT}/UserInfo/GetBillFlowAll`, params);

//可使用优惠券列表
export const GetAllEffectiveCoupon = params =>
  fly.get(`${PORT}/UserInfo/GetAllEffectiveCouponPageable`, params);
//已使用优惠券列表
export const GetAllInvalidCouponNew = params =>
  fly.get(`${PORT}/UserInfo/GetAllInvalidCouponNewPageable`, params);

//已过期优惠券列表

export const GetAllExpiredCoupon = params =>
  fly.get(`${PORT}/UserInfo/GetAllExpiredCouponPageable`, params);

//获取子账号列表
export const GetSubMemberList = params =>
  fly.post(`${PORT}/Store/GetSubMemberList`, params);
//获取子账号订单列表
export const GetSubMemberOrderList = params =>
  fly.post(`${PORT}/Store/GetSubMemberOrderList`, params);
export const GetSubMemberOrderListExport = params =>
  fly.post(`${PORT}/Store/GetSubMemberOrderListExport`, params);

//获取充值产品
export const GetCrrechargeProduct = params =>
  fly.get(`${PORT}/VisaProduct/GetCrrechargeProduct`, params);
//获取用户余额
export const GetUserBalance = params =>
  fly.get(`${PORT}/UserInfo/GetUserBalancePC`, params);

// 保险产品列表
export const ProductList = params =>
  fly.get(`${PORT}/Insurance/ProductList`, params);

// 保险产品详情
export const ProductDetail = params =>
  fly.get(`${PORT}/Insurance/ProductDetail`, params);

// 保险订单详情
export const InsuranceOrderDetail = params =>
  fly.get(`${PORT}/Insurance/OrderDetail`, params);

// 保险下单
export const InsuranceOrder = options =>
  fly.post(`${PORT}/Insurance/Order`, options);

// 保险支付
export const GetInsurancePay = options =>
  fly.post(`${PORT}/OrderAudit/GetInsurancePay`, options);

// 保险订单
export const GetInsuranceOrderList = options =>
  fly.get(`${PORT}/Insurance/OrderListPC`, options);

// 删除保险订单 Insurance/DelOrder
export const DelInsuranceOrder = options =>
  fly.get(`${PORT}/Insurance/DelOrder`, options);

export const GetViasPay = options =>
  fly.post(`${PORT}/OrderAudit/GetVisaPay`, options);
export const PayQuery = options =>
  fly.get(`${PORT}/OrderAudit/PayQuery`, options);
export const GetRechargePay = options =>
  fly.post(`${PORT}/OrderAudit/GetRechargePay`, options);
export const RechargeQuery = options =>
  fly.get(`${PORT}/OrderAudit/RechargeQuery`, options);
//签证工具
export const MakeCertificate = params =>
  fly.post(`${RPRT3}/Certificate/MakePC`, params);
export const FileDownload = params =>
  fly.get(`${RPRT3}/Certificate/FileDownload`, params);

// 获取店铺管理信息Store/GetStore
export const GetStoreInfo = params => fly.get(`${PORT}/Store/GetStore`, params);

export const GetOrderCount = params =>
  fly.get(`${PORT}/VisaOrder/GetOrderCount`, params);

// 保存店铺管理信息
export const SaveStoreInfo = params =>
  fly.post(`${PORT}/Store/SaveStore`, params);

export const InsuranceDownload = params =>
  fly.get(`${PORT}/Insurance/download`, params);
// 发送验证码 RegisterSendMsg
// 发送验证码
export const GetStorePricePC = params =>
  fly.get(`${PORT}/Store/GetStorePricePC`, params);

// 店铺价格保存
export const UpdateStorePricePC = params =>
  fly.post(`${PORT}/Store/UpdateStorePricePC`, params);

// 发送验证码
export const RegisterSendMsg = params =>
  fly.post(`${PORT}/VisaLogin/RegisterSendMsg`, params);

export const GetCountryList = params =>
  fly.get(`${PORT}/VisaProduct/GetCountryList`, params);

export const BalancePayment = params =>
  fly.post(`${PORT}/PayMent/BalancePayment`, params);

// 搜索热门
export const GetHotSearchCuntry = params =>
  fly.get(`${PORT}/VisaProduct/GetHotSearchCuntry`, params);

// 老官网热门产品
export const GetHotProduct = params =>
  fly.get(`${RPRT3}/Product/GetHotProduct`, params);
export default {
  GetHotCountry,
  GetCountryBook,
  GetCountryHoliday,
  GetCountryHolidayList,
  GetCountryBookList,
  GetNewsConsult,
  GetNewsDetails,
  GetCountrys,
  CheckCodeLogin,
  GetProduct,
  SeachCountry,
  GetDetail,
  ExportPdfDetail,
  ExportWordDetail,
  ProductList,
  ProductDetail,
  InsuranceOrderDetail,
  InsuranceOrder,
  GetCompany,
  GetBillFlowAll,
  GetPassengerProgress,
  GetAllEffectiveCoupon,
  GetAllInvalidCouponNew,
  GetAllExpiredCoupon,
  GetSubMemberList,
  GetSubMemberOrderList,
  GetSubMemberOrderListExport,
  VisaDetial,
  PostOrder,
  GetOrderDetail,
  PlaceOrder,
  GetAddressList,
  EditAddressDetail,
  DelAddress,
  SetDefaultAddress,
  SFOrder,
  AddAddress,
  GetOrderList,
  CancelOrder,
  GetInsurancePay,
  GetViasPay,
  PayQuery,
  MakeCertificate,
  FileDownload,
  GetInsuranceOrderList,
  DelInsuranceOrder,
  GetStoreInfo,
  GetOrderCount,
  SaveStoreInfo,
  RegisterSendMsg,
  GetUserBalance,
  GetCrrechargeProduct,
  GetRechargePay,
  BalancePayment,
  RechargeQuery,
  InsuranceDownload,
  GetBanner,
  GetStorePricePC,
  UpdateStorePricePC,
  GetCountryList,
  GetVisaList,
  GetHotSearchCuntry,
  GetHotProduct
};



// WEBPACK FOOTER //
// ./src/api/api.js